import { restClient } from '../client';


export type CheckResetPasswordTokenInput = {
  reset_password_token: string;
  is_invite_token?: boolean;
};


export type CheckResetPasswordTokenOutput = {
  error?: string;
  status: 'error' | 'valid';
};


export const checkResetPasswordToken = (params: CheckResetPasswordTokenInput) => restClient.request<CheckResetPasswordTokenOutput>('/api/v1/auth/check-reset-password-token', {
  method: 'GET',
  params: params,
});
